import { Trees } from "lucide-react";
import { useSiteSettings } from "@/contexts/SettingsContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * BrandLogo - displays the site logo from admin settings.
 * Falls back to the Trees icon inside an emerald square if no logo_image is set.
 * Used on Login, Register, ForgotPassword, etc. so logo is consistent everywhere.
 */
export default function BrandLogo({ size = "md", className = "" }) {
  const { settings } = useSiteSettings();
  const logoImage = settings?.logo_image || "";
  const logoUrl = logoImage
    ? (logoImage.startsWith("/api/") ? `${BACKEND_URL}${logoImage}` : logoImage)
    : "";

  const dims = size === "lg"
    ? { box: "h-16 w-16", icon: "h-9 w-9", img: "h-16 max-w-[120px]" }
    : size === "sm"
    ? { box: "h-9 w-9", icon: "h-5 w-5", img: "h-9 max-w-[60px]" }
    : { box: "h-12 w-12", icon: "h-6 w-6", img: "h-12 max-w-[90px]" };

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={settings?.app_name || "Logo"}
        className={`${dims.img} w-auto object-contain ${className}`}
        data-testid="brand-logo-image"
      />
    );
  }
  return (
    <div className={`${dims.box} rounded-xl bg-emerald-700 flex items-center justify-center ${className}`} data-testid="brand-logo-fallback">
      <Trees className={`${dims.icon} text-white`} />
    </div>
  );
}
